<template>
    <div
        v-if="badges.length"
        class="flex space-x-2 items-center mt-1 mb-3"
    >
        <DBadge
            v-for="(badge, index) in badges"
            :key="`badge-${index}`"
            :type="badge.color"
            :icon="badge.icon"
            rounded
        >
            {{ badge.text }}
        </DBadge>
    </div>
</template>

<script setup>
    import { DBadge } from '@digistorm/spark'

    const props = defineProps({
        badges: Array,
    })
</script>
